import React, { useState } from 'react'

export default function EmbedBadge({ uniqueId }) {
  const [copied, setCopied] = useState(false)
  const certUrl = `https://humanorigin.app/certificate/${uniqueId}`
  const badgeHtml = `<a href="${certUrl}" target="_blank" rel="noopener noreferrer" style="display:inline-flex;align-items:center;gap:8px;background:#0a0a0a;color:#c8f55a;font-family:sans-serif;font-size:13px;font-weight:600;padding:8px 14px;border-radius:8px;border:1px solid rgba(200,245,90,0.3);text-decoration:none;"><svg width="16" height="16" viewBox="0 0 16 16" fill="none"><circle cx="8" cy="8" r="7" stroke="#c8f55a" stroke-width="1.5"/><path d="M5 8l2 2 4-4" stroke="#c8f55a" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>Human Origin Verified</a>`

  function copy() {
    navigator.clipboard.writeText(badgeHtml)
    setCopied(true)
    setTimeout(() => setCopied(false), 2000)
  }

  return (
    <div className="embed-badge-section">
      <h3>Embed this badge</h3>
      <p>Drop this on your portfolio or website to link back to your certificate.</p>
      <div style={{ marginBottom: 16 }}>
        <a href={certUrl} target="_blank" rel="noopener noreferrer" className="human-origin-badge">
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
            <circle cx="8" cy="8" r="7" stroke="#c8f55a" strokeWidth="1.5"/>
            <path d="M5 8l2 2 4-4" stroke="#c8f55a" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
          Human Origin Verified
        </a>
      </div>
      <pre className="embed-code">{badgeHtml}</pre>
      <button className="btn btn-secondary btn-sm" style={{ width: '100%' }} onClick={copy}>
        {copied ? '✓ Copied!' : 'Copy HTML'}
      </button>
    </div>
  )
}
